<!-- 高德地图 展示坐标点 -->

<style lang="less">
.amap-location {
  position: relative;
  overflow-y: auto;
  &.hidden-geo .amap-geolocation-con {
    display: none !important;
  }
  #amap-location {
    width: inherit;
    height: 100%;
  }
  .amap-logo,
  .amap-copyright {
    display: none !important;
  }
}
</style>

<template>
  <div class="amap-location" :class="{'hidden-geo': hiddenGeo}" @click="handleClick">
    <div :id="`amap-location-${id}`" :style="style"></div>
  </div>
</template>

<script>
/* eslint-disable comma-dangle,no-undef */
export default {
  props: {
    value: Array, // 经纬坐标
    zoom: {
      type: Number,
      default: 15
    },
    // 隐藏 【回到我的位置】按钮
    hiddenGeo: {
      type: Boolean,
      default: true
    },
    modify: Boolean, // 编辑位置（可点）
    onLoaded: Function, // 当地图加载完成时
    onDestroy: Function, // 当地图销毁时
  },
  data() {
    return {
      id: String(Math.random()).slice(3, 8),
      style: {},
      flag: false
    }
  },
  watch: {
    value(lnglat) {
      if (!this.$options.$map) this.initMap();
      if (lnglat && lnglat.length === 2 && !this.modify) {
        this.resetMarker(lnglat)
      }
    }
  },
  $timer: null,
  $map: null,
  $marker: null,
  mounted() {
    const _this = this

    _this.$options.$timer = setInterval(() => {
      _this.$set(_this.style, 'height', _this.$el.offsetHeight + 'px')
    }, 5e2);

    _this.initMap()

    // 展示当前位置
    if (_this.value && _this.value.length === 2) {
      _this.resetMarker(_this.value)
    }
  },
  beforeDestroy() {
    if (typeof this.onDestroy === 'function') {
      this.onDestroy()
    }

    if (this.$options.$timer) clearInterval(this.$options.$timer)

    // 销毁地图
    if (this.$options.$map) this.$options.$map.destroy()
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
    // 初始化地图
    initMap() {
      const self = this

      const map = new AMap.Map(`amap-location-${self.id}`, {
        resizeEnable: true,
        // center: [116.397428, 39.90923],
        zoom: self.zoom
      })

      // self.$.addControl(new AMap.Scale())

      // self.$.addControl(new AMap.Geolocation())

      // 点击事件
      // self.$.on('click', function (e) {
      // const lnglat = [e.lnglat.getLng(), e.lnglat.getLat()]
      // if (self.modify) {
      //   self.$emit('input', lnglat)
      //   self.setMarker(lnglat)
      // }
      // })

      // 自动定位
      const geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        timeout: 1e6, // 超过10秒后停止定位，默认：5s
        buttonPosition: 'RB', // 定位按钮的停靠位置
        buttonOffset: new AMap.Pixel(13, 130), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        zoomToAccuracy: true // 定位成功后是否自动调整地图视野到定位点
      });
      // geolocation.getCurrentPosition();
      // AMap.event.addListener(geolocation, 'complete', function onComplete(data) {
      //   var getLongitude = data.position.getLng();
      //   var getLatitude = data.position.getLat();
      //   alert(getLongitude + '---' + getLatitude + '我的天') // 弹出获得的经纬度
      // });
      // const toolBar = new AMap.ToolBar({
      //   liteStyle: true
      // });

      // 增加控制组件
      map.addControl(geolocation);
      // map.addControl(toolBar);
      self.modify && geolocation.getCurrentPosition();
      geolocation.getCityInfo((status, result) => {
        this.$emit('getLocation', result)
      })
      map.panBy(0, 1);

      self.modify && AMapUI.loadUI(['misc/PositionPicker'], function (PositionPicker) {
        const positionPicker = new PositionPicker({
          // 开启拖拽选址
          // dragMap 拖拽地图模式
          // dragMarker 拖拽Marker模式
          mode: 'dragMap',
          map: self.$options.$map
        });
        // positionPicker.setMode('dragMap');
        console.log('positionPicker ===>', positionPicker);
        positionPicker.on('success', function (positionResult) {
          const value = [
            positionResult.position.lng,
            positionResult.position.lat
          ]
          self.$emit('input', value)
          self.$emit('detail', positionResult)
          self.setMarker(value)
        });
        positionPicker.on('fail', function (positionResult) {
          console.log('fail', positionResult);
        });

        positionPicker.start();
      });

      // 地图拖拽
      map.on('dragstart', e => {
        if (!self.modify) {
          return
        }
        // 清除所有信息框
        if (self.$options.$marker) self.$options.$map.remove(self.$options.$marker)
        self.flag = true
        self.$options.$map.clearInfoWindow();
        this.$emit('dragstart')
      });

      // const geolocationComplete = AMap.event.addListener(
      //   geolocation,
      //   'complete',
      //   ({ position }) => {
      //     console.log('自动定位', position)
      //     map.setZoomAndCenter(self.defaultZoom, position);
      //   }
      // );

      // // 事件注销
      // self.$once('hook:beforeDestroy', () => {
      //   AMap.event.removeListener(geolocationComplete);
      // });

      // self.$set(self, 'map', map);
      self.$options.$map = map;

      // if (typeof self.onLoaded === 'function') {
      //   self.onLoaded()
      // }
    },
    resetMarker(lnglat) {
      this.$options.$map.setZoomAndCenter(this.zoom, lnglat)
      this.setMarker(lnglat)
    },
    setMarker(point) {
      if (this.$options.$marker) this.$options.$map.remove(this.$options.$marker)
      // eslint-disable-next-line no-new
      this.$options.$marker = new AMap.Marker({
        map: this.$options.$map,
        position: point || this.value,
        // offset: new AMap.Pixel(-26, -13),
        autoRotation: true
      });
    },
    setCenter() {
      this.$options.$map.setCenter(this.value)
    }
  }
}
</script>
